<template>
  <div id="chat-contacts">
    <div @click="$emit('selection', c)" class="chat-contact" v-for="c in contacts" :key="c.id">
      <div class="icon shadow" :style="{ background: getRandomColor() }">
        <span>{{ initials(c.name) }}</span>
      </div>
      <div class="content-outer">
        <div class="name">
          <span>
            {{ c.name }}
          </span>
          <span class="time">
            {{ timeAgo(c.lastMessage.time) }}
          </span>
        </div>
        <div class="last-message">
          {{ shorten(c.lastMessage.content) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Time from '@/mixins/Time'
export default {
  name: 'ChatContacts',
  props: {
    contacts: {
      type: Array
    }
  },
  mixins: [ Time ],
  methods: {
    initials (name) {
      return name.split(' ').map(str => str.charAt(0).toUpperCase()).join('')
    },
    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    shorten (msg) {
      return msg.length > 30 ? msg.substring(0, 29) + '...' : msg
    }
  }
}
</script>
<style lang="scss">
#chat-contacts {
  .chat-contact {
    cursor: pointer;
    border-bottom: #444 2px solid;
    padding: 10px;
    display: flex;
    .name, .last-message {
      color: #fff;
      .time {
        font-weight: bold;
        font-size: 10px;
      }
    }
    .content-outer {
      padding: 5px;
    }
    .icon {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
      span {
        width: 40px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/ChatContacts.vue